import * as types from './mutation_types'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      isLoading: false,
      items: [],
      view: []
    })
  },

  [types.SET_ITEMS] (state, items) {
    Object.assign(state, {
      items
    })
  },

  [types.SET_VIEW] (state, view) {
    Object.assign(state, {
      view
    })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  }
}
